import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import styled from "styled-components";
import { StaticImage } from "gatsby-plugin-image"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleDown } from '@fortawesome/free-solid-svg-icons';

const ContactSection = (props) =>
{

  const Gradient = styled.div`
  background:  linear-gradient( rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7));
`
  const data = useStaticQuery(graphql`
    query {
      allImageSharp {
        edges {
          node {
            fluid(maxWidth: 3000) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    `)
  return (

    <BackgroundImage id="contact-section" class="mt-2" fluid={data.allImageSharp.edges
      .find((element) =>
      {

        if (element.node.fluid.src.split('/').pop() === "bandenverzameling.jpg")
        {
          return element;
        }
        return null;
      }).node.fluid} style={{
        backgroundAttachment: 'fixed',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}>
      <Gradient>
        <section class="hero is-medium">
          <div class="hero-body">
            <div class="container has-text-centered">
              <h1 class="has-text-white-ter title pb-5 mainfont" >{props.intro}</h1>
              <h2 class="description has-text-white-ter mainfont is-size-4" ><b>{props.addresstitle}</b></h2><br />
              <p class="description has-text-white-ter mainfont is-size-5">
                {props.address}
              </p>
              <br /><br /><br />
              <h2 class="description has-text-white-ter mainfont is-size-4" ><b>{props.email}</b></h2><br />
              <p class="description has-text-white-ter mainfont is-size-5">
                nicky@dutchtyres.nl<br />
                lorenzo@dutchtyres.nl
              </p>
            </div>
          </div>
        </section>
      </Gradient>
    </BackgroundImage >
  )

}
export default ContactSection;